import React, { useState } from "react";
import Header from "components/ui/Header";
import BreadcrumbNavigation from "components/ui/BreadcrumbNavigation";
import FooterSection from "pages/homepage-with-3d-construction-experience/components/FooterSection";

import GlobalSphereBackground from "../../components/3d/GlobalSphereBackground";
import CoverageHero from "./components/CoverageHero";
import CoverageMap from "./components/CoverageMap";
import CoverageRegions from "./components/CoverageRegions";
import { CITIES } from "./components/coverageData"

const NationalCoverage = () => {
  const [activeCityKey, setActiveCityKey] = useState("bogota");

  return (
    <div className="min-h-screen relative bg-transparent">
      <GlobalSphereBackground />

      {/* Overlay para contraste SIRECC */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(11,22,32,0.92) 0%, rgba(29,41,70,0.88) 50%, rgba(11,22,32,0.98) 100%)",
        }}
      />

      <div className="relative z-10">
        <Header />

        <main className="max-w-7xl mx-auto px-6 lg:px-8 pt-6 pb-24">
          <BreadcrumbNavigation />
          <CoverageHero />

          <div className="grid lg:grid-cols-5 gap-8 mt-8">
            {/* Panel de regiones/ciudades (izquierda) */}
            <div className="lg:col-span-2">
              <CoverageRegions
                activeCityKey={activeCityKey}
                setActiveCityKey={setActiveCityKey}
              />
            </div>

            {/* Mapa (derecha) */}
            <div className="lg:col-span-3">
              <CoverageMap activeCityKey={activeCityKey} />
            </div>
          </div>
        </main>

        <FooterSection />
      </div>
    </div>
  );
};

export default NationalCoverage;
